import type {ReactNode} from 'react';

import {AppLayout} from '@ds/layout';
import {type HeaderDataPayload} from '@ds/types';
import BottomNavigation from 'shell/layout/BottomNavigation/BottomNavigation';
import LayoutHeader from 'shell/layout/LayoutHeader/LayoutHeader';

type LayoutProps = {
  hasHeader?: boolean;
  hasNavigate?: boolean;
  modalTitle?: string;
  modalText?: string;
  linkWithConfirmation?: boolean;
  title?: string;
  children: ReactNode;
  hasBack?: boolean;
  hasLeftIcon?: boolean;
  link?: string | number;
  leftIconLink?: string;
  headerData?: HeaderDataPayload;
  extra?: ReactNode;
};

const Layout = ({
  hasHeader,
  hasNavigate,
  modalTitle,
  modalText,
  linkWithConfirmation = false,
  title,
  children,
  hasBack,
  hasLeftIcon,
  link,
  leftIconLink,
  headerData,
  extra
}: LayoutProps) => {
  return (
    <div className="absolute inset-0 flex flex-row">
      <AppLayout
        className="min-h-0 flex-1 overflow-hidden bg-gray-13"
        contentScroll={false}
        contentClassName="bg-white"
        header={
          hasHeader ? (
            <LayoutHeader
              title={title}
              hasBack={hasBack}
              link={link}
              modalTitle={modalTitle}
              modalText={modalText}
              linkWithConfirmation={linkWithConfirmation}
              hasLeftIcon={hasLeftIcon}
              leftIconLink={leftIconLink}
              headerData={headerData}
              extra={extra}
            />
          ) : undefined
        }
        tabBar={hasNavigate ? <BottomNavigation badges={[{id: 2, text: 'جدید'}]} /> : undefined}
      >
        {children}
      </AppLayout>
    </div>
  );
};

export default Layout;
